'use strict';

import {reverseUrl} from 'utils/django';

import modalDirective from '../../rest-modal';
import template from './template.html';


export default modalDirective({
	template: template,
	refreshIncident: true,
});
